import { render } from "./InstallPwa.vue?vue&type=template&id=53f69998"
import script from "./InstallPwa.vue?vue&type=script&lang=js"
export * from "./InstallPwa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__